export default function TableHeader() {
  return (
    <div className="rule-header px-9 py-5">
      <p className="match">Matches</p>
      <p className="numbers">Numbers</p>
      <p className="prize">Prize</p>
    </div>
  );
}
